export const ASKOKEY_PREFIX = 'ASKOKEY_';
export const ORDER_UPDATED = 'ORDER_UPDATED';
